// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActiveLearningLessonPage_wrapper__SnXMG"};